import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetGroup(id: string | undefined) {
  return useQuery(queries.userGroups.getGroupById(id || ''))
}
